import { createDeepEqualSelector } from '../utils/selectors';

const selectUI = (state) => state.ui;

export const selectSidebarVisibility = createDeepEqualSelector(selectUI, (ui) => ui.sidebarVisible);

export const selectIsMobileNavVisible = createDeepEqualSelector(selectUI, (ui) => ui.mobileNavVisible);

export const selectNotification = createDeepEqualSelector(selectUI, (ui) => ui.notification);

export const selectIsUpdateSubscriptionModalVisible = createDeepEqualSelector(
  selectUI,
  (ui) => ui.updateSubscriptionModalVisible,
);
